module.exports = __webpack_public_path__ + "static/media/oddparents3.925aa313.gif";